import { openStepCostModal } from '@process-advisor/process-miner/api/methods/modals/stepCostModal';
import { openDiscoveryRuleModal } from '@process-advisor/process-miner/api/methods/modals/discoveryRuleModal';
import { openFindingModal } from '@process-advisor/process-miner/api/methods/modals/findingModal';
import { openProgressModal } from '@process-advisor/process-miner/api/methods/modals/openProgressModal';
import { updateProgressModal } from '@process-advisor/process-miner/api/methods/modals/updateProgressModal';
import { closeProgressModal } from '@process-advisor/process-miner/api/methods/modals/closeProgressModal';
import { updateStepCost } from '@process-advisor/process-miner/api/methods/modals/updateStepCost';
import { setMinPercTasks} from '@process-advisor/process-miner/api/methods/modals/setMinPercTasks'
import { processAnalytics} from '@process-advisor/process-miner/api/methods/modals/processAnalytics'
import { histogram} from '@process-advisor/process-miner/api/methods/modals/histogram'
import { eventDetail} from '@process-advisor/process-miner/api/methods/modals/eventDetail'
import { taskDetail} from '@process-advisor/process-miner/api/methods/modals/taskDetail'
import { taskLifecycle} from '@process-advisor/process-miner/api/methods/modals/taskLifecycle'
import { openLifecycleModalSingle} from '@process-advisor/process-miner/api/methods/modals/lifecycleModalSingle'
import { editDiscoveryRuleModal } from '@process-advisor/process-miner/processMiner/processMiner';
import { viewWorkflowModal } from '@process-advisor/process-miner/processMiner/processMiner';
import { editCostModal } from '@process-advisor/process-miner/processMiner/processMiner';
import { openCommentsModal } from '@process-advisor/process-miner/api/methods/modals/commentsModal';
import { updateComments } from '@process-advisor/process-miner/api/methods/modals/updateComments'
import { deleteCost } from '@process-advisor/process-miner/api/methods/modals/deleteCost'
import { updateAnalytic } from '@process-advisor/process-miner/api/methods/modals/updateAnalytic'
import { openSaveModal } from '@process-advisor/process-miner/api/methods/modals/openSaveModal';
import { openWorkflowModal } from '@process-advisor/process-miner/api/methods/modals/workflowModal';
import { openStepMetricsModal} from '@process-advisor/process-miner/api/methods/modals/stepMetricsModal'


export const modalsMethods = {
    openDiscoveryRuleModal,
    openFindingModal,
    updateStepCost,
    setMinPercTasks,
    processAnalytics,
    histogram,
    taskDetail,
    eventDetail,
    taskLifecycle,
    openLifecycleModalSingle,
    editDiscoveryRuleModal,
    openProgressModal,
    closeProgressModal,
    openCommentsModal,
    updateComments,
    openStepCostModal,
    deleteCost,
    editCostModal,
    updateProgressModal,
    openSaveModal,
    updateAnalytic,
    viewWorkflowModal,
    openWorkflowModal,
    openStepMetricsModal
};
